module.exports = __webpack_public_path__ + "593a3d53/img/product-icon-grey.b248963c.svg";